import axios from "axios";
import { getCookie } from "../../getcookie.js";
const dockUrl = process.env.REACT_APP_DOCK_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: getCookie("mawalog"),
};

export const getLocationApi = async (term) => {
    try {
        const response = await axios.get(apiAdminUrl + `get_location?term=` + term, {
            headers: header,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getDeptApi = async (term) => {

    try {
        const response = await axios.get(apiAdminUrl + `get_department?term=` + term, {
            headers: header,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};




export const getCustomerListApi = async (params) => {
    console.log("dockUrl", dockUrl);
    console.log("dockUrl", process.env.REACT_APP_DOCK_API_URL);
    try {
        const response = await axios.get(
            dockUrl + `customer?` + params,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const saveCustomerApi = async (body) => {
    try {
        const response = await axios.post(`${dockUrl}customer`, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const updateCustomerApi = async (body, id) => {
    try {
        const response = await axios.put(`${dockUrl}customer/` + id, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const getCustomerApi = async (id) => {
    try {
        const response = await axios.get(`${dockUrl}customer/` + id, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};

export const getTransporterListApi = async (params) => {
    try {
        const response = await axios.get(
            dockUrl + `transporter?` + params,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const saveTransporterApi = async (body) => {
    try {
        const response = await axios.post(`${dockUrl}transporter`, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const updateTransporterApi = async (body, id) => {
    try {
        const response = await axios.put(`${dockUrl}transporter/` + id, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const getTransporterApi = async (id) => {
    try {
        const response = await axios.get(`${dockUrl}transporter/` + id, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};



export const getVendorListApi = async (params) => {
    try {
        const response = await axios.get(
            dockUrl + `vendor?` + params,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const saveVendorApi = async (body) => {
    try {
        const response = await axios.post(`${dockUrl}vendor`, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const updateVendorApi = async (body, id) => {
    try {
        const response = await axios.put(`${dockUrl}vendor/` + id, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const getVendorApi = async (id) => {
    try {
        const response = await axios.get(`${dockUrl}vendor/` + id, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};




export const getDeleteCustomerApi = async (id) => {

    try {
        const response = await axios.delete(
            dockUrl + `customer/` + id,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getDeleteTransporterApi = async (id) => {

    try {
        const response = await axios.delete(
            dockUrl + `transporter/` + id,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getDeleteVendorApi = async (id) => {

    try {
        const response = await axios.delete(
            dockUrl + `vendor/` + id,
            {
                headers: header,
            }
        );
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};